import { useEffect } from "react";
import mixpanel from "mixpanel-browser";
import { useSetRecoilState } from "recoil";
import { webTestTypeAtom } from "../../recoil/webTestTypeAtom";
import { webFunnelApi } from "../../api/webFunnelApi";
import useMixpanelProfileMkt from "../../hooks/useMixpanelProfileMkt";

export default function PromotionInitializer() {
  const setWebTestType = useSetRecoilState(webTestTypeAtom);
  const setPromotionPeople = useMixpanelProfileMkt("v4");

  useEffect(() => {
    let isMounted = true;

    const initTestType = async () => {
      const waitForMixpanelAndInit = async (retryCount: number) => {
        if (!isMounted) return;

        // mixpanel.promotion 인스턴스 확인
        const instance = (mixpanel as any).promotion;
        const distinctId = instance?.get_distinct_id?.();

        if (distinctId) {
          // Mixpanel Ready
          instance?.identify?.(distinctId);

          // page-data/save 등 후속 API에서 재사용할 수 있도록 distinctId를 저장
          localStorage.setItem("WEB_FUNNEL_DISTINCT_ID", distinctId);

          const storedType = localStorage.getItem("WEB_FUNNEL_TEST_TYPE");
          if (storedType) {
            // Case 1: localStorage hit
            if (isMounted) {
              setWebTestType({ type: storedType });
              setPromotionPeople({
                "테스트 유형": storedType.toUpperCase(),
                "로그인 페이지 유형": "D",
              });

              // API 호출은 트래킹용이므로 실패해도 진행
              try {
                await webFunnelApi.begin(distinctId, storedType);
              } catch (e) {
                console.error("Failed to log begin event", e);
              }
            }
          } else {
            // Case 2: API call
            try {
              const res = await webFunnelApi.begin(distinctId);
              const testType = res.result?.testType;

              if (testType && isMounted) {
                localStorage.setItem("WEB_FUNNEL_TEST_TYPE", testType);
                setWebTestType({ type: testType });
                setPromotionPeople({
                  "테스트 유형": testType.toUpperCase(),
                  "로그인 페이지 유형": "D",
                });
              } else if (isMounted) {
                // 타입이 없는 경우 (오류 상황 등)
                setWebTestType({}); // 빈 객체로 설정하여 로딩 해제
              }
            } catch (e) {
              console.error(e);
              if (isMounted) setWebTestType({}); // 에러 시 로딩 해제
            }
          }
        } else {
          // Retry
          if (retryCount > 0) {
            setTimeout(() => waitForMixpanelAndInit(retryCount - 1), 200);
          } else {
            // Timeout Fallback
            if (isMounted) {
              const storedType = localStorage.getItem("WEB_FUNNEL_TEST_TYPE");
              if (storedType) {
                setWebTestType({ type: storedType });
              } else {
                setWebTestType({}); // 로딩 해제
              }
            }
          }
        }
      };

      // Start Polling (max 10s)
      waitForMixpanelAndInit(50);
    };

    initTestType();

    return () => {
      isMounted = false;
    };
  }, [setWebTestType, setPromotionPeople]);

  return null;
}
